export enum DelegationAddFromAllMileagesParamsVehicleType {
  COMPANY_OWNED = "COMPANY_OWNED",
  CAR_GT_900CM3 = "CAR_GT_900CM3",
  CAR_LE_900CM3 = "CAR_LE_900CM3",
  MOTORCYCLE = "MOTORCYCLE",
  MOPED = "MOPED",
}

type DelegationAddFromAllMileagesParams = {
  companyId?: string;
  dateSince?: Date;
  dateTo?: Date;
  cargoCompanyName?: string;
  humanId?: number;
  mileageNumber?: string;
  workerName?: string;
  cardNumber?: string;
  address?: string[];
  startAddress?: string[];
  midAddress?: string[];
  endAddress?: string[];
  distanceMax?: number;
  distanceMin?: number;
  vehicleType?: DelegationAddFromAllMileagesParamsVehicleType;
};

export default DelegationAddFromAllMileagesParams;
